<select #comboBox
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [(ngModel)]="selectedSellAreaCode" [disabled]="disabled" [hidden]="!visible" [class.combo-box-required]="required"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.dataList">
    <option value="{{item.SellAreaCode}}">{{item.SellAreaCodeName}}</option>
  </ng-template>
</select>
